import { UsersActionType, UsersAction } from '../actions/userActions';
import { CardUser } from '@card/types';

export interface UserState {
  user: CardUser | null;
}

const initialState: UserState = {
  user: null
};

function userReducers(state = initialState, action: UsersAction): UserState {
  switch (action.type) {
    case UsersActionType.Fetch:
      return {
        ...state,
        user: null
      };
    case UsersActionType.FetchSuccess:
      return {
        ...state,
        user: action.payload
      };
    case UsersActionType.FetchError:
      return {
        ...state,
        user: null
      };
    default:
      return state;
  }
}

export default userReducers;
